import { render, staticRenderFns } from "./BillPreSendDetail.vue?vue&type=template&id=ffcde36a&scoped=true"
import script from "./BillPreSendDetail.vue?vue&type=script&lang=js"
export * from "./BillPreSendDetail.vue?vue&type=script&lang=js"
import style0 from "./BillPreSendDetail.vue?vue&type=style&index=0&id=ffcde36a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffcde36a",
  null
  
)

export default component.exports